let timer, map, BMap,markerObjs=[];
const createMap = () => {
    const dom = document.querySelector('#one_map');
    timer = setTimeout(() => {
        if (!Object.prototype.hasOwnProperty.call(window, 'BMap') || !dom) {
            clearTimeout(timer)
            createMap();
        } else {
            BMap = window.BMap;
            map = new window.BMap.Map(dom); // 创建Map实例
            // map.centerAndZoom("上海",15); 
            map.addControl(new window.BMap.MapTypeControl({
                mapTypes: [
                    window.BMAP_NORMAL_MAP,
                    window.BMAP_HYBRID_MAP
                ]
            }));
            map.enableScrollWheelZoom(true);
        }
    }, 100);

}
const getMap = () => {
    if (map) {
        return map;
    }
    return null
}

const addMarker = (option) => {
    var point = new window.BMap.Point(option.lng, option.lat);
    map.centerAndZoom(point, 12);
    var marker = new window.BMap.Marker(point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中

    var label = new window.BMap.Label(option.title, {
        offset: new window.BMap.Size(20, -10),
    });
    marker.setLabel(label);
    map.addOverlay(marker);
    markerObjs.push(marker);
}
const on = (type,fn)=>{
    map.addEventListener(type, (e)=>{
        fn(e.point); 
    });
}
const removeOverlays = () => {
    markerObjs.forEach(overlay => {
        map.removeOverlay(overlay);
    });
}
export default {
    createMap,
    getMap,
    BMap,
    addMarker,
    removeOverlays,
    on,
}


// WEBPACK FOOTER //
// ./src/package/one_map_bmap.js